 <form (ngSubmit)="opprett()" [formGroup]="skjema" #skjemaelement>
  <inline-skjema>
    <inline-skjema-tittel>{{ 'Opprett ny gruppe' | translate }}</inline-skjema-tittel>

    <div class="kontainer">
      <gruppe-logo-og-farge-skjema [skjema]="skjema.controls.logoOgFarge" />
      <fieldset>
        <i class="nygruppe-markør ion-ios-plus-outline" (click)="giFokusTilNyGruppeFelt()"></i>
        <mat-form-field class="tittel">
          <mat-label>{{ 'Navn på ny gruppe (f.eks.: Styret, Ledergruppen)'|translate }}</mat-label>
          <input matInput [formControl]="skjema.controls.tittel" name="tittel" data-testid="tittel-felt">
          @if (skjema.controls.tittel.hasError('maxlength')) {
            <mat-error data-testid="maxlength">{{ skjema.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'Møtemal'|translate }}</mat-label>
          <mat-select [formControl]="skjema.controls.mal" [compareWith]="erValgt" panelClass="velg-gruppemal--alternativer" data-testid="gruppemal-felt">
            <mat-select-tips>
              {{ "Hva slags gruppe lager du? Våre møtemaler inneholder tilpassede møtesaker, roller, tema og sakstyper."|translate }}
            </mat-select-tips>
            <mat-select-trigger>
              @if(skjema.value.mal){
                {{skjema.value.mal.gruppemal.navn}}
              }
            </mat-select-trigger>
            @for (mal of gruppemaler | async; track mal.id) {
              <mat-option [value]="mal">
                <div class="mal">
                  <div class="tittel">{{ mal.gruppemal.navn }}</div>
                  <div class="beskrivelse">{{ mal.gruppemal.beskrivelse }}</div>
                </div>
              </mat-option>
            }
            <mat-option [value]="null" class="mat-option--skillelinje-over">{{ 'Ingen mal'|translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'Møtenavn'|translate }}</mat-label>
          <input matInput [formControl]="skjema.controls.moetenavn" data-testid="møtenavn-felt">
          @if (skjema.controls.moetenavn.hasError('maxlength')) {
            <mat-error data-testid="maxlength">{{ skjema.controls.moetenavn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
        <div class="i18nvalg">
          <mat-form-field>
            <mat-label>{{ 'Standard språk'|translate }}</mat-label>
            <lokale-velger [skjemakontroll]="skjema.controls.spraak"/>
            @if (!skjema.controls.tidssone.hasError('ugyldig')) {
              <mat-hint>{{'Standard språk og tidssone benyttes i genererte PDF-rapporter og eposter'|translate}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field class="tidssone">
            <mat-label>{{ 'Standard tidssone'|translate }}</mat-label>
            <tidssone-velger [skjemakontroll]="skjema.controls.tidssone"/>
            @if (skjema.controls.tidssone.hasError('ugyldig')) {
              <mat-error>{{'Ugyldig tidssone'|translate}}</mat-error>
            }
          </mat-form-field>
        </div>
        <mat-form-field>
          <mat-label>{{ 'Avtale'|translate }}</mat-label>
          <mat-select [formControl]="skjema.controls.avtale" [compareWith]="erValgt" panelClass="velg-avtale--alternativer" data-testid="avtale-felt">
            <mat-select-tips>
              {{ "Tilhører gruppen en eksisterende avtale/fakturamottaker, eller skal du ta Styreplan i bruk et nytt sted/ny fakturamottaker?"|translate }}
            </mat-select-tips>
            @for (avtale of avtaler | async; track avtale.id) {
              @if (kanLeggeTilNyGruppeIAvtale(avtale)) {
                <mat-option [value]="avtale">{{avtale.navn}}</mat-option>
              }
            }
            <mat-option [value]="nyAvtaleVerdi" class="mat-option--skillelinje-over">{{ 'Opprett ny avtale'|translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        @if(skjema.controls.avtale.value){
          <mat-form-field>
            <mat-label>{{ 'Organisasjonsnavn'|translate }}</mat-label>
            <input matInput [formControl]="skjema.controls.organisasjonsnavn" data-testid="organisasjonsnavn-felt">
            @if (skjema.controls.organisasjonsnavn.hasError('maxlength')) {
              <mat-error data-testid="maxlength">{{ skjema.controls.organisasjonsnavn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
            }
          </mat-form-field>
        }
        @if (visGodtaBetingelser()) {
          <mat-slide-toggle [formControl]="skjema.controls.godtarAvtaleVilkaar" (click)="bekreftAvtalebetingelser()" class="ny-avtale" data-testid="godta-vilkår-felt">
            {{ 'Jeg godtar avtalevilkårene'|translate }}
          </mat-slide-toggle>
        }

        <inline-melding type="info" voksHorisontalt="true" data-testid="møte-navn-info">
          <div>{{'Møter i denne gruppen vil hete'|translate}}:</div>
          <span class="skjemaverdi">{{skjema.value.moetenavn}}</span>
          @if(skjema.value.moetenavn == ''){<span class="skjemaverdi-mangler">{{'møtenavn'|translate}}</span>}
          {{'i'|translate}}
          <span class="skjemaverdi">{{skjema.value.tittel}}</span>
          @if(skjema.value.tittel == ''){<span class="skjemaverdi-mangler">{{'gruppenavn'|translate}}</span>}
          {{'i'|translate}}
          @if(skjema.value.organisasjonsnavn == ''){
            <span class="skjemaverdi-mangler">{{'avtale'|translate}}</span>
          } @else {
            <span class="skjemaverdi">{{skjema.value.organisasjonsnavn}}</span>
          }
        </inline-melding>
      </fieldset>
    </div>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <div class="handlinger">
        <button mat-stroked-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}">
          {{ "Opprett ny gruppe"|translate }}
        </button>
      </div>
    </inline-skjema-handlinger>
  </inline-skjema>
</form>

